import { render, staticRenderFns } from "./procurement-type.vue?vue&type=template&id=7abe1c15&"
import script from "./procurement-type.vue?vue&type=script&lang=js&"
export * from "./procurement-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports